<script>
import controller from "../../scripts/controller/controller.js";
import {nextTick} from "vue";

export default {

	mounted() {
		controller.events.on('scrollToId', id => this.handlerScrollToId(id));
	},

	unmounted() {
		controller.events.off('scrollToId', id => this.handlerScrollToId(id));
	},

	watch: {
		data(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.checkScrollToSelfByUrl();
			}
		}
	},

	methods: {
		handlerScrollToId(id) {
			if (id === this.data?.id) {
				this.handlerScrollToSelf();
			}
		},

		handlerScrollToSelf()  {
			window.scrollTo({top: this.$el.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 4, behavior: 'smooth'});
		},

		async checkScrollToSelfByUrl(){
			if (window.location.hash && window.location.hash.replace('#','') === this.data?.id) {
				await nextTick();
				setTimeout(this.handlerScrollToSelf, 500);
			}
		}
	}
};
</script>